import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
export function GiftCardPromo() {
  return <section className="py-20 bg-black text-white overflow-hidden" data-id="element-169">
      <div className="container mx-auto px-4" data-id="element-170">
        <div className="relative bg-zinc-900 border border-gold/30 p-8 md:p-16 flex flex-col md:flex-row items-center gap-12" data-id="element-171">
          {/* Decorative Background Element */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-gold/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-172" />

          <div className="w-full md:w-1/2 relative z-10" data-id="element-173">
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.8
          }} viewport={{
            once: true
          }} data-id="element-174">
              <div className="flex items-center gap-3 text-gold mb-6" data-id="element-175">
                <Gift size={24} data-id="element-176" />
                <span className="uppercase tracking-[0.3em] text-[10px] font-bold" data-id="element-177">
                  Perfect for any occasion
                </span>
              </div>
              <h2 className="text-3xl md:text-5xl font-serif mb-6 leading-tight" data-id="element-178">
                Give the Gift of TriLyn
              </h2>
              <p className="text-gray-400 text-base md:text-lg mb-10 leading-relaxed max-w-lg" data-id="element-179">
                Choose a digital gift card and let them select their favorite
                piece from TriLyn’s culturally inspired collections.
              </p>
              <Link to="/product/gift-card" data-id="element-180">
                <button className="bg-gold text-black px-10 py-4 text-sm uppercase tracking-widest font-bold hover:bg-white transition-all duration-300 shadow-xl shadow-gold/10" data-id="element-181">
                  Buy Gift Card
                </button>
              </Link>
            </motion.div>
          </div>

          <div className="w-full md:w-1/2 relative" data-id="element-182">
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.8
          }} viewport={{
            once: true
          }} className="relative aspect-video md:aspect-square lg:aspect-video rounded-lg overflow-hidden flex items-center justify-center" data-id="element-183">
              <img src="https://cdn.magicpatterns.com/uploads/43ocbeErzL86xDTvHUMoKt/56bc39_3b36d8682b4e40f4bc9e19e8307687eb~mv2.jpg" alt="TriLyn Gift Card" className="w-full h-full object-cover shadow-2xl" data-id="element-184" />
              {/* Floating Accents */}
              <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-gold/20 rounded-full blur-2xl" data-id="element-185" />
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}